import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';


const swiper = document.querySelectorAll('[data-swiper]');

swiper.forEach(function (element) {
    const settings = JSON.parse(element.dataset.swiper);

    new Swiper(element, settings);
});